export class SupersetDto {
  static setup(data) {
    return { token: data.token, dashboardId: data.dashboardEmbeddedUuid };
  }
}
